import React from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { useParams } from "react-router-dom";

// Get display string from column config (Header or accessor)
function getHeaderLabel(col) {
  if (col == null) return "";
  if (typeof col === "string") return col;
  return col.Header ?? col.accessor ?? col.id ?? "";
}

// Get value from row using accessor (supports "nested.path")
function getCellValue(row, col) {
  if (row == null) return "";
  const accessor = typeof col === "object" && col != null ? (col.accessor ?? col.id) : col;
  if (accessor == null || accessor === "") return "";
  if (typeof accessor === "function") return String(accessor(row) ?? "");
  const val = typeof accessor === "string" && accessor.includes(".")
    ? accessor.split(".").reduce((o, k) => (o != null ? o[k] : undefined), row)
    : row[accessor];
  if (val == null) return "";
  if (typeof val === "object") return JSON.stringify(val);
  return String(val);
}

export default function ReportGenerator({ data, headers }) {
  const { report } = useParams();
  const generatePDF = () => {
    const doc = new jsPDF(
      "l", // orientation
      "pt", // unit
      "a4" // format
    );
    const columns = Array.isArray(headers) ? headers : [];
    const headRow = columns.map(getHeaderLabel);
    const bodyRows = (Array.isArray(data) ? data : []).map((item) =>
      columns.map((col) => getCellValue(item, col))
    );
    doc.autoTable({
      head: [headRow],
      body: bodyRows,
      startY: 20,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [41, 128, 185] },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      margin: { top: 20 },
    });
    doc.save(`SalesReport-${Date.now()}.pdf`);
  };

  return (
    <div className="flex flex-row space-x-5">
      {/* export to excel */}
      <button
        onClick={() => {
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          const fileExtension = ".xlsx";
          const fileName = `Report-${report}-${Date.now()}`;
          const ws = XLSX.utils.json_to_sheet(data);

          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const dataExcel = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(dataExcel, fileName + fileExtension);
        }}
        className="flex hover:text-green-600 flex-row space-x-2 items-center"
      >
        <FaFileExcel className="mr-2 h-10" />
        {/* icon */}
        Export to Excel
      </button>
      <button
        className="flex hover:text-red-600 flex-row space-x-2 items-center"
        onClick={generatePDF}
      >
        <FaFilePdf className="mr-2 h-10" />
        {/* icon */}
        Generate PDF
      </button>
    </div>
  );
}
